/**
 * @generated SignedSource<<8bbc01c487da700a68fd3bb5ee647fda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoListEventData$data = {
  readonly authorizedData: {
    readonly tracks: ReadonlyArray<{
      readonly resolution: ReadonlyArray<number> | null | undefined;
    }>;
  } | null | undefined;
  readonly created: string;
  readonly creators: ReadonlyArray<string>;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly isLive: boolean;
  readonly series: {
    readonly id: string;
    readonly title: string;
  } | null | undefined;
  readonly syncedData: {
    readonly audioOnly: boolean;
    readonly duration: number;
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
    readonly thumbnail: string | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "VideoListEventData";
};
export type VideoListEventData$key = {
  readonly " $data"?: VideoListEventData$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoListEventData">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "VideoListEventData"
};

(node as any).hash = "412f02b1dbaf4a1ad214892814cfb89a";

export default node;
